import { Modal } from "ant-design-vue";
import lodash from "lodash";
import moment from "moment";
import {
    createFieldRadioGroup,
    createFieldSelect,
    createFieldTextArea
} from "../../../../components/input/template-builder/template-builder.logic";
import { createColumnDate, createColumnInput, createColumnSelect } from "../../../../components/table/c-table.logic";
import i18n from "../../../../i18n";
import router from "../../../../router";
import store from "../../../../store";
import { conditionFormChecker, copyForm, putField } from "../../../../utils/form";
import { /*callRequestDoc,*/ callRequestStatus, callRequestType } from "../../storage-location/request/request.section";
import { defineAsyncComponent } from "vue";
import { callUser } from "../../storage-location/request/requestor/requestor.section";

const CIcon = defineAsyncComponent(() => import("../../../../components/icon/CIcon"));

export const callFreeSaleAttachment = ({ searchQuery }) =>
    store.dispatch("resource/v1/master/lookup/cacheFindAllByGroup", { group: "FREE_SALE_ATTACHMENT", value: searchQuery });

export const callFreeSaleObjective = ({ searchQuery }) =>
    store
        .dispatch("resource/v1/master/lookup/cacheFindAllByGroup", { group: "REQUEST_OBJECTIVE", value: searchQuery })
        .then(items => items.filter(item => ["1", "2"].includes(item.key)))

export const callUserObjective = ({ searchQuery }) =>
    store
        .dispatch("resource/v1/master/lookup/cacheFindAllByGroup", { group: "USER_OBJECTIVE", value: searchQuery })
        .then(items => items.filter(item => ["2", "4"].includes(item.key)));

export const callFreeSale = ({ searchQuery, userInfo, isOfficerCreate,  }) => {
    const where = [
        { name: "isActive", type: "Boolean", operator: "=", value: true },
        { name: "isTemp", type: "Boolean", operator: "=", value: false },
        { name: "refStatus.key", type: "String", operator: "=", value: "complete" },
        { name: "expireDate", type: "Date", operator: ">=", value: moment().format("YYYY-MM-DD") }
    ];
    if (!isOfficerCreate) {
        where.push(
            { openBucket: true, constant: true, name: "1", type: "String", operator: "=", value: "1" }, // 1
            { name: "refUserCompany.id", type: "UUID", operator: "=", value: userInfo?.refParent?.id || userInfo?.id },

            { logic: "OR", openBucket: true, constant: true, name: "1", type: "String", operator: "=", value: "1" }, // 2
            { name: "refUserCompany.userAuthorizes.isActive", type: "Boolean", operator: "=", value: true },
            { name: "refUserCompany.userAuthorizes.isTemp", type: "Boolean", operator: "=", value: false },
            { name: "refUserCompany.userAuthorizes.refStatus.key", type: "String", operator: "=", value: "active" },
            { name: "refUserCompany.userAuthorizes.refAuthorizeType.key", type: "String", operator: "=", value: "2" },
            { name: "refUserCompany.userAuthorizes.refAuthorize.id", type: "UUID", operator: "=", value: userInfo?.refParent?.id || userInfo?.id },

            { name: "refUserCompany.userAuthorizes.refAuthorize.userAuthorizes.isActive", type: "Boolean", operator: "=", value: true },
            { name: "refUserCompany.userAuthorizes.refAuthorize.userAuthorizes.isTemp", type: "Boolean", operator: "=", value: false },
            { name: "refUserCompany.userAuthorizes.refAuthorize.userAuthorizes.refStatus.key", type: "String", operator: "=", value: "active" },
            { name: "refUserCompany.userAuthorizes.refAuthorize.userAuthorizes.refAuthorizeType.key", type: "String", operator: "=", value: "1" },
            {
                name: "refUserCompany.userAuthorizes.refAuthorize.userAuthorizes.refAuthorize.id",
                type: "Getpath",
                operator: "=",
                value: "refUserCompany.id"
            },
            { closeBucket: true, constant: true, name: "1", type: "String", operator: "=", value: "1" }, // 2
            { closeBucket: true, constant: true, name: "1", type: "String", operator: "=", value: "1" } // 1
        );
    }
    if (searchQuery) {
        where.push({ name: "approveCode", type: "String", operator: "like", value: searchQuery });
    }
    return store
        .dispatch("resource/v1/transaction/freeSale/search", {
            criteria: {
                isDistinct: true,
                select: ["id", "approveCode", "refUserCompany.id", "refUserCompany.fullNameTh"],
                page: 0,
                size: 1000000,
                where,
                sort: [{ name: "approveCode", type: "DESC" }]
            }
        })
        .then(page => page.data);
};
export const callFreeSaleFull = ({ id }) => {
    return store
        .dispatch("resource/v1/transaction/freeSale/search", {
            criteria: {
                select: [
                    "**",
                    "refUserCompany.refPersonType.*",
                    "refUser.refPersonType.*",
                    "refHazObject.**",
                    "refHaz.*",
                    "refHaz.refType.*",
                    "refInformProduct.*",
                    "refInformProduct.refHazSpecies.*",
                    "refInformProduct.refHazObject.*",
                    "refInformProduct.refHazObject.refSpecies.*",
                    "refInformProduct.refHazObject.HazObjectCoordinate.refCoordinateCustoms.refUnit.*",
                    "refInformProduct.refHaz.*",
                    "refInformProduct.refHaz.refType.*",
                    "refInformProduct.refFreeSale.*",
                    "refInform.*",
                    "refInform.refOperation.*",
                    "refInform.refTransportByWay.*",
                    "refInform.refTransportObjective.*",
                    "refInform.refOriginDestinationCountry.*",
                    "refInform.refImportCheckpoint.*",
                    "refInform.refExportCheckpoint.*",
                    "refInform.refPassCustoms.*",
                ],
                page: 0,
                size: 1,
                where: [{ name: "id", type: "UUID", operator: "=", value: id }],
                children: [
                    {
                        name: "refUserCompany.addresses",
                        select: ["*"],
                        page: 0,
                        size: 1,
                        where: [{ name: "refAddressType.key", type: "String", operator: "=", value: "1" }]
                    },
                    {
                        name: "refUser.addresses",
                        select: ["*"],
                        page: 0,
                        size: 1,
                        where: [{ name: "refAddressType.key", type: "String", operator: "=", value: "1" }]
                    },
                    {
                        name: "addresses",
                        select: ["*", "refAddressType.*", "refProvince.*", "refAmphur.*", "refTambon.*"],
                        page: 0,
                        size: 1,
                        where: [{ name: "refId", type: "UUID", operator: "=", value: id }]
                    },
                    {
                        name: "products",
                        select: ["*", "refProduct.**"],
                        page: 0,
                        size: 1000000,
                        sort: [{ name: "createDate", type: "ASC" }]
                    },
                    {
                        name: "attachments",
                        select: ["*"],
                        page: 0,
                        size: 1000000,
                        sort: [{ name: "createDate", type: "ASC" }]
                    },
                    {
                        name: "refHaz.statuses",
                        asName: "refHaz.lastStatus.forReceiveRemark",
                        select: ["**"],
                        page: 0,
                        size: 1,
                        where: [
                            {
                                name: "refStatus.key",
                                type: "String",
                                operator: "in",
                                value: ["waitReceive", "waitResponseCustoms", "waitApprove", "waitPayment", "approve", "notApprove", "complete"]
                            }
                        ],
                        sort: [{ name: "createDate", type: "DESC" }]
                    },
                    {
                        name: "refInform.products",
                        select: [
                            "**",
                            "refHazObject.refSpecies.*",
                            "refCoordinateCustoms.refUnit.*",
                            "refHaz.refManufactureCountry.*",
                            "refHaz.refType.*",
                            "refHaz.refProduct.**",
                            "refHazLicense.refQuantityUnit.*",
                            "refFreeSale.*"
                        ],
                        page: 0,
                        size: 1000000,
                        where: [
                            { name: "refHazSpecies.key", type: "String", operator: "!=", value: "1" },
                            // { name: "refFreeSale.id", type: "UUID", operator: "=", value: null }
                        ],
                        sort: [{ name: "createDate", type: "ASC" }],
                        children: [
                            {
                                name: "refHaz.products",
                                select: ["*", "refProduct.**"],
                                page: 0,
                                size: 1000000,
                                sort: [{ name: "createDate", type: "ASC" }]
                            },
                            {
                                name: "refHazObject.hazObjectCoordinates",
                                select: ["*", "refCoordinateCustoms.*", "refCoordinateCustoms.refUnit.*"],
                                page: 0,
                                size: 1000000
                            },
                            {
                                name: "refHaz.mainSubStances",
                                select: ["*", "refSubStance.*", "refUnit.*"],
                                page: 0,
                                size: 1000000,
                                sort: [{ name: "createDate", type: "ASC" }]
                            },
                        ]
                    },
                    {
                        name: "refInformProduct.refHaz.products",
                        select: [
                            "*",
                            "refProduct.*",
                            "refProduct.refParent.*",
                        ],
                        page: 0,
                        size: 1000000,
                        sort: [{ name: "createDate", type: "ASC" }],
                    },
                    {
                        name: "refInform.statuses",
                        asName: "refInform.lastStatus.forReceiveRemark",
                        select: ["**"],
                        page: 0,
                        size: 1,
                        where: [
                            {
                                name: "refStatus.key",
                                type: "String",
                                operator: "in",
                                value: ["waitReceive", "waitResponseCustoms", "waitApprove", "waitPayment", "approve", "notApprove", "complete"]
                            }
                        ],
                        sort: [{ name: "createDate", type: "DESC" }]
                    },
                ]
            }
        })
        .then(page => page.data[0]);
};

export const createColumns = () => {
    const columns = [
        createColumnInput({
            title: () => i18n.global.t("model.freeSale.refUserCompany"),
            dataIndex: "refFreeSaleTemp.refUserCompany.companyNameTh",
            dataIndexValue: ({ record }) =>
                record.refFreeSaleTemp?.refUserCompany?.refPersonType?.key === "1"
                    ? record.refFreeSaleTemp?.refUserCompany?.companyNameTh
                    : record.refFreeSaleTemp?.refUserCompany?.fullNameTh,
            customRender: ({ record, column }) => column.dataIndexValue({ record })
        }),
        createColumnInput({ title: () => i18n.global.t("model.request.draftCode"), dataIndex: "draftCode", align: "center" }),
        createColumnInput({ title: () => i18n.global.t("model.request.requestCode"), dataIndex: "requestCode", align: "center" }),
        createColumnInput({
            title: () => i18n.global.t("views.request.approveCode"),
            dataIndex: "refFreeSale.approveCode",
            align: "center"
        }),
        createColumnDate({
            title: () => i18n.global.t("model.freeSale.expireDate"),
            dataIndex: "refFreeSale.expireDate",
            align: "center"
        }),
        //todo bug search
        createColumnInput({
            title: () => i18n.global.t("model.freeSale.registrationCertificate"),
            dataIndex: "refFreeSaleTemp.refHaz.approveCode",
            dataIndexValue: ({ record }) =>
                record.refFreeSaleTemp?.refObjective?.key === "1"
                    ? record.refFreeSaleTemp?.refHaz?.approveCode
                    : record.refFreeSaleTemp?.refInform?.approveCode,
            customRender: ({ record, column }) => column.dataIndexValue({ record }),
            align: "center"
        }),
        createColumnInput({
            title: () => i18n.global.t("model.haz.tradeNameTh"),
            dataIndex: "refFreeSaleTemp.refHaz.tradeNameTh",
            dataIndexValue: ({ record }) =>
                record.refFreeSaleTemp?.refObjective?.key === "1"
                    ? record.refFreeSaleTemp?.refHaz?.tradeNameTh
                    : record.refFreeSaleTemp?.refInformProduct?.refHaz?.tradeNameTh,
            customRender: ({ record, column }) => column.dataIndexValue({ record }),
            align: "center"
        }),
        createColumnSelect({
            title: () => i18n.global.t("model.freeSale.refObjective"),
            dataIndex: "refFreeSaleTemp.refObjective.value",
            inputProp: () => ({ list: callFreeSaleObjective, optLabel: "value" }),
            search: { name: "refFreeSaleTemp.refObjective.id" }
        }),
        createColumnSelect({
            title: () => i18n.global.t("model.request.refRequestType"),
            dataIndex: "refRequestType.value",
            customRender: ({ record }) => <div>
                <span>{record.refRequestType?.value}</span>
                {record.isSignCa ? <CIcon class="ml-1" file="sign.svg"></CIcon> : null}
            </div>,
            inputProp: () => ({
                list: ({ searchQuery }) => callRequestType({ searchQuery }).then(items => items.filter(item => !["3"].includes(item.key))),
                optLabel: "value" }),
            search: { name: "refRequestType.id" },
            align: "center"
        }),
        createColumnSelect({
            title: () => i18n.global.t("model.request.refStatus"),
            dataIndex: "refStatus.value",
            inputProp: () => ({ list: callRequestStatus, optLabel: "value" }),
            search: { name: "refStatus.id" },
            align: "center"
        })
    ];
    return columns;
};

export const createField = ({ props, data, refs, key }) => {
    const { viewOnly } = props;
    const { useForm } = data;
    const { modelRef } = useForm;
    const model = key ? lodash.get(modelRef, key) : modelRef;
    const prefix = key ? `${key}.` : "";
    return putField({
        data,
        fields: [
            createFieldSelect({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}refRequestType`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.request.refRequestType"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.refRequestType,
                            "onUpdate:value": value => {
                                const oldValue = model.refRequestType;
                                model.refRequestType = value;
                                if (
                                    (["2"].includes(oldValue?.key) || (!["1"].includes(oldValue?.key) && ["1"].includes(value?.key))) &&
                                    model.refFreeSale
                                ) {
                                    Modal.confirm({
                                        title: i18n.global.t("views.request.modal.change", { text: i18n.global.t("model.request.refRequestType") }),
                                        autoFocusButton: "cancel",
                                        onOk: () => {
                                            if (["1"].includes(value?.key)) {
                                                const { createForm } = require("./request.logic");
                                                cloneFreeSale({
                                                    model: {
                                                        ...createForm({ props, data, refs }),
                                                        id: model.id,
                                                        version: model.version,
                                                        isActive: model.isActive,
                                                        refStatus: model.refStatus,
                                                        refRequestDoc: model.refRequestDoc,
                                                        draftCode: model.draftCode,
                                                        requestCode: model.requestCode
                                                    }
                                                });
                                            } else {
                                                cloneFreeSale({ model, id: model.refFreeSale?.id });
                                            }
                                        },
                                        onCancel: () => {
                                            model.refRequestType = oldValue;
                                        }
                                    });
                                }
                            },
                            disabled: viewOnly,
                            list: ({ searchQuery }) => callRequestType({ searchQuery }).then(items => items.filter(item => !["3"].includes(item.key))),
                            optLabel: "value",
                            allowClear: false
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.value`) }
            }),
            createFieldSelect({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}refFreeSale`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.storageLocation.approveCode"),
                inputProp: ({ field }) => {
                    return lodash.merge(
                        {
                            value: model.refFreeSale,
                            "onUpdate:value": value => {
                                const oldValue = model.refFreeSale;
                                model.refFreeSale = value;
                                if (oldValue) {
                                    Modal.confirm({
                                        title: i18n.global.t("views.request.modal.change", {
                                            text: i18n.global.t("model.freeSale.approveCode")
                                        }),
                                        autoFocusButton: "cancel",
                                        onOk: () => cloneFreeSale({ model, id: value?.id }),
                                        onCancel: () => {
                                            model.refFreeSale = oldValue;
                                        }
                                    });
                                } else {
                                    cloneFreeSale({ model, id: value?.id });
                                }
                            },
                            disabled: viewOnly,
                            list: ({ searchQuery }) =>
                                callFreeSale({
                                    searchQuery,
                                    userInfo: store.state.resource.auth.info?.user,
                                    isOfficerCreate:
                                    model.isOfficerCreate
                                }),
                            renderLabel: ({ item }) => (
                                <div>
                                    {item.approveCode} - {item.refUserCompany?.fullNameTh}
                                </div>
                            ),
                            allowClear: false
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    );
                },
                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.value`) }
            }),
            createFieldTextArea({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}lastStatus.forRequestRemark.0.remark`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.request.descToOfficer"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.lastStatus.forRequestRemark?.[0]?.remark,
                            "onUpdate:value": value => (model.lastStatus.forRequestRemark[0].remark = value),
                            disabled: viewOnly
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            createFieldTextArea({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}lastStatus.forReceiveRemark.0.remark`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.request.descToUserCompany"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.lastStatus.forReceiveRemark?.[0]?.remark,
                            "onUpdate:value": value => (model.lastStatus.forReceiveRemark[0].remark = value),
                            disabled: viewOnly
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            {
                visible: () => true,
                colProp: () => ({ xs: 24, md: 12}),
                formItemRender: () => <div></div>
            },
            createFieldRadioGroup({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}refFreeSaleTemp.refObjective`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.freeSale.refObjective"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.refFreeSaleTemp.refObjective,
                            "onUpdate:value": value => {
                                if(value.key === "1") {
                                    model.refFreeSaleTemp.refOperation = data.userObjectives.find(d => d.key === "4")
                                    model.refFreeSaleTemp.refInform = null;
                                    model.refFreeSaleTemp.refInformProduct = null;
                                    data.useFreeSaleAttachments = data.freeSaleAttachments.filter(d => ["1"].includes(d.key));
                                } else if ( value.key === "2") {
                                    model.refFreeSaleTemp.refOperation = data.userObjectives.find(d => d.key === "2")
                                    model.refFreeSaleTemp.refHaz = null;
                                    model.refFreeSaleTemp.refHazObject = null;
                                    model.refFreeSaleTemp.tradeNameTh = null;
                                    model.refFreeSaleTemp.tradeNameEn = null;
                                    model.refFreeSaleTemp.isSolid = null;
                                    model.refFreeSaleTemp.solid = null;
                                    model.refFreeSaleTemp.isLiquid = null;
                                    model.refFreeSaleTemp.liquid = null;
                                    model.refFreeSaleTemp.refSubStanceType = null;
                                    model.refFreeSaleTemp.manufacturer = null;
                                    model.refFreeSaleTemp.manufacturerEn = null;
                                    model.refFreeSaleTemp.refManufactureCountry = null;
                                    model.refFreeSaleTemp.ph = null;
                                    model.refFreeSaleTemp.refType = null;
                                    model.refFreeSaleTemp.toUse = null;
                                    model.refFreeSaleTemp.refSubStanceTypeMain = null;
                                    model.refFreeSaleTemp.refAnalysisAgency = null;
                                    model.refFreeSaleTemp.refAnalysisMethod = null;
                                    model.refFreeSaleTemp.products = [];
                                    data.useFreeSaleAttachments = data.freeSaleAttachments.filter(d => ["2", "3"].includes(d.key))
                                }
                                lodash.remove(model.refFreeSaleTemp?.attachments, d => !d.id);
                                model.refFreeSaleTemp?.attachments?.forEach(d => (d.isDelete = true));
                                data.useFreeSaleAttachments.forEach(item =>
                                    model.refFreeSaleTemp.attachments.push({ documentName: item.value, attribute: lodash.cloneDeep(item.attribute) })
                                );
                                model.refFreeSaleTemp.refObjective = value;
                                model.refFreeSaleTemp.freeSaleProducts = [];
                            },
                            disabled: viewOnly,
                            list: callFreeSaleObjective,
                            optLabel: "value"
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.value`) }
            }),
        ]
    });
};

export const cloneFreeSale = ({ model, id }) => {
    if (id) {
        callFreeSaleFull({ id }).then(freeSale => {
            const refFreeSaleTemp = copyForm({ form: { ...freeSale, isTemp: true } });
            if (id) {
                refFreeSaleTemp.attachments.forEach((d, index) => (d.refRealId = freeSale.attachments[index].id));
                refFreeSaleTemp.addresses.forEach((d, index) => (d.refRealId = freeSale.addresses[index].id));
                refFreeSaleTemp.products.forEach((d, index) => (d.refReal = { id: freeSale.products[index].id }));

                if (freeSale.refObjective.key === "2") {
                    refFreeSaleTemp.refInform.products = freeSale.refInform?.products
                }
            }
            return callUser({ userCompanyId: refFreeSaleTemp.refUserCompany.id }).then(users => {
                refFreeSaleTemp.refUser = users.find(d => d.id === store.state.resource.auth.info?.user?.id) || refFreeSaleTemp.refUser;
                router.push({
                    name: router.currentRoute.value.name,
                    params: {
                        props: JSON.stringify({
                            form: {
                                ...model,
                                refRequestDoc: freeSale.refRequestDoc,  //null
                                refDepartment: freeSale.refDepartment,
                                refFreeSaleTemp
                            }
                        })
                    },
                    query: { _timestamp: new Date().getTime() }
                });
            });
        });
    } else {
        router.push({
            name: router.currentRoute.value.name,
            params: { props: JSON.stringify({ forceDefault: true, form: model }) },
            query: { _timestamp: new Date().getTime() }
        });
    }
};